(function () {
    "use strict";

    angular
        .module("app")
        .directive("divisionSearchHelp", ["SearchFactory", divisionSearchHelp]);

    function divisionSearchHelp(searchFactory) {
        return {
            restrict: "E",
            link: function (scope) {

                scope.search = function (forValidation) {
                    if (scope.readOnly === true) {
                        return;
                    }

                    if (forValidation && (!scope.displayValue || scope.displayValue.trim().length === 0)) {
                        scope.divisionKey = "";
                        scope.divisionName = "";
                        scope.prevDisplayValue = "";
                        scope.displayValue = "";
                        return;
                    }

                    scope.needToValidate = forValidation ? true : false;

                    if (forValidation && (scope.prevDisplayValue === scope.displayValue || scope.divisionName === scope.displayValue)) {
                        scope.needToValidate = false;
                        return;
                    }

                    var modalSearch = searchFactory.divisionSearch(scope.sapBrandId, function (division) {
                        scope.setValue(division);
                    });

                    modalSearch.startSearch(forValidation, [scope.displayValue, ""]);
                };

                scope.setValue = function (division) {
                    scope.divisionKey = division ? division.DivisionKey : "";
                    scope.divisionName = division ? division.DivisionName : "";
                    scope.displayValue = scope.divisionName;

                    if (scope.prevDisplayValue !== scope.displayValue) {
                        scope.setDirtyCallback();
                    }

                    scope.prevDisplayValue = scope.displayValue;
                    scope.needToValidate = false;
                };

                scope.displayValue = scope.divisionName;
                scope.prevDisplayValue = scope.displayValue;

                scope.$watch("divisionName", function (newValue) {
                    scope.displayValue = newValue;
                });

                if (scope.enableKeyWatch) {
                    scope.$watch("divisionKey", function (newValue) {
                        if (newValue && newValue.toString().trim().length > 0) {
                            var modalSearch = searchFactory.divisionSearch(scope.sapBrandId, function (division) {
                                scope.setValue(division);
                            });

                            modalSearch.startSearch(true, ["", newValue], true);
                        } else {
                            scope.setValue(null);
                        }
                    });
                }

            },
            scope: { divisionKey: "=", divisionName: "=?", readOnly: "=", required: "=", controlName: "@", sapBrandId: "=", needToValidate: "=?", setDirtyCallback: "&", enableKeyWatch: "=" },
            templateUrl: templateUrl("app/directives/searchHelp/searchHelp.directive.html")
        };
    }
})();

